export default "__VITE_ASSET__xCDVUN0R__"